import { Component, OnInit, ViewChild } from '@angular/core';
import { NgbPopover, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { JwtHelperService } from '@auth0/angular-jwt';
import { forkJoin, Observable } from 'rxjs';
type Notification = {
	id: string;
	title: string;
	releaseDate: string;
	releaseEndDate: string;
	text: string;
	viewed?: boolean;
};

@Component({
	selector: 'app-notification',
	templateUrl: './notification.component.html',
	styleUrls: ['./notification.component.css'],
})
export class NotificationComponent implements OnInit {
	@ViewChild('p') popover: NgbPopover;

	userId = null;
	notificationCount: number = 0;
	notifications: Notification[] = [];
	notificationsViews = [];
	notificationIndex: number = 0;

	constructor(
		private modalService: NgbModal,
		private http: HttpClient,
		private JwtHelperService: JwtHelperService
	) {}

	ngOnInit(): void {
		const token = localStorage.getItem('currentUser');
		this.userId = this.JwtHelperService.decodeToken(token).id;
		this.loadNotificationsAndViews();
	}

	getUserNotificationViews(): Observable<Notification[]> {
		return this.http.post<Notification[]>(
			`${environment.apiUrl}/main/userNotificationViews`,
			{ userId: this.userId }
		);
	}

	getNotifications(): Observable<Notification[]> {
		return this.http.get<Notification[]>(
			`${environment.apiUrl}/main/notifications`
		);
	}

	loadNotificationsAndViews(): void {
		forkJoin({
			views: this.getUserNotificationViews(),
			notifications: this.getNotifications(),
		}).subscribe(
			({ views, notifications }) => {
				this.notificationsViews = views;
				this.notifications = notifications.map((notification) => ({
					...notification,
					viewed: this.notificationsViews.includes(notification.id),
				}));

				this.countNotifications();
			},
			(error) => {
				console.error(
					'There was an error fetching the notifications or views:',
					error
				);
			}
		);
	}
	toggleOpen() {
		if (this.popover.isOpen()) {
			this.popover.close();
		} else {
			this.popover.open();
		}
	}
	open(content, index) {
		this.notificationIndex = index;
		this.setAsViewed(index);
		this.countNotifications();
		this.modalService.open(content, {
			modalDialogClass: 'modal-dialog-notification',
			size: 'xl',
		});
	}

	updateView(notificationId: string, userId: string) {
		const requestBody = { notificationId, userId };
		this.http
			.post(`${environment.apiUrl}/main/notificationViews`, requestBody)
			.subscribe({
				next: (response) => {
					console.log('Update sent successfully', response);
				},
				error: (error) => {
					console.error('Error sending update', error);
				},
			});
	}

	setAsViewed(index) {
		if (this.notifications[index].viewed) {
			return;
		} else {
			this.updateView(this.notifications[index].id, this.userId);
			this.notifications[index].viewed = true;
			this.countNotifications();
		}
	}

	markAllRead() {
		this.notifications = this.notifications.map((notification) => ({
			...notification,
			viewed: true,
		}));
		this.notifications.forEach((notification) => {
			this.updateView(notification.id, this.userId);
		});
		this.countNotifications();
		this.popover.close();
	}
	countNotifications() {
		this.notificationCount = this.notifications.filter(
			(notification) => !notification.viewed
		).length;
	}
}
